import { CurrenciesAction, SET_CURRENCIES } from '@Actions/currencies';

import { ICurrency } from '@ClientApi/formFields';

interface ICurrenciesState {
  currenciesList: ICurrency[];
}

export const defaultState: ICurrenciesState = {
  currenciesList: []
};

export function currenciesReducer(state = defaultState, action: CurrenciesAction): ICurrenciesState {
  switch (action.type) {
    case SET_CURRENCIES: {
      return {
        ...state,
        currenciesList: action.payload
      };
    }
    default:
      return state;
  }
}
